import * as Yup from 'yup';
import React, { useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import palette from 'src/theme/palette';
import LoadingButtonWrapper from 'src/components/LoadingButtonWrapper';
import InputField from 'src/components/InputField';
import { api } from 'src/Api';
import { toast } from 'react-toastify';
import { Form, FormikProvider, useFormik } from 'formik';

export default function UpdatePassword() {
  const token = localStorage.getItem('token');

  const [isSaveLoading, setSaveLoading] = useState(false);

  const RegisterSchema = Yup.object().shape({
    currentPassword: Yup.string().required('Current Password is required'),
    password: Yup.string().required('New Password is required'),
    confirmPassword: Yup.string()
      .required('Confirm New Password is required')
      .oneOf([Yup.ref('password')], 'The new password and confirm password do not match.')
  });

  const formik = useFormik({
    initialValues: {
      currentPassword: '',
      password: '',
      confirmPassword: ''
    },
    validationSchema: RegisterSchema,
    onSubmit: () => {
      handleUpdatePassword();
    }
  });

  const { errors, values, touched, handleSubmit, getFieldProps } = formik;

  const handleUpdatePassword = () => {
    setSaveLoading(true);

    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formData = new FormData();
    formData.append('current_password', values.currentPassword);
    formData.append('new_password', values.password);
    formData.append('new_password_confirmation', values.confirmPassword);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formData,
      redirect: 'follow'
    };

    fetch(api.update_password, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          formik.resetForm();
          toast.success(result.message);
        } else {
          toast.error(result.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => {
        setSaveLoading(false);
      });
  };

  return (
    <Box
      sx={{
        px: { xs: 3.5, sm: 3.5 },
        pt: { xs: 1, sm: 3 }
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <Typography
            sx={{ fontSize: 15, fontFamily: 'poppinsBold', color: palette.primary.titledark }}
          >
            Change password
          </Typography>
          <Typography
            sx={{ fontSize: 12, fontFamily: 'poppinsRegular', color: palette.primary.title }}
          >
            Update your password associated with your account.
          </Typography>
        </Grid>

        <Grid item xs={12} md={8} sx={{ ml: { xs: 0, sm: 3 } }}>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Grid container>
                <Grid item xs={12}>
                  <InputField
                    name="currentPassword"
                    label="Current Password"
                    type="password"
                    placeholder=""
                    backgroundColor={'#ffffff'}
                    {...getFieldProps('currentPassword')}
                    error={touched.currentPassword && errors.currentPassword}
                    helperText={touched.currentPassword && errors.currentPassword}
                    labelFontMedium
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputField
                    name="password"
                    label="New Password"
                    type="password"
                    placeholder=""
                    backgroundColor={'#ffffff'}
                    {...getFieldProps('password')}
                    error={touched.password && errors.password}
                    helperText={touched.password && errors.password}
                    labelFontMedium
                  />
                </Grid>

                <Grid item xs={12}>
                  <InputField
                    name="confirmPassword"
                    label="Confirm New Password"
                    type="password"
                    placeholder=""
                    backgroundColor={'#ffffff'}
                    {...getFieldProps('confirmPassword')}
                    error={touched.confirmPassword && errors.confirmPassword}
                    helperText={touched.confirmPassword && errors.confirmPassword}
                    labelFontMedium
                  />
                </Grid>

                <Grid item xs={12}>
                  <LoadingButtonWrapper
                    title="Save"
                    type="submit"
                    loading={isSaveLoading}
                    disabled={!formik.isValid}
                    style={{
                      width: isSaveLoading ? 130 : 50,
                      paddingLeft: 10,
                      paddingRight: 10,
                      borderRadius: 5,
                      letterSpacing: 0.5,
                      boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
                      marginTop: 20,
                      marginBottom: 30,
                      transition: 'width 0.3s ease, background-color 0.3s ease, transform 0.3s ease'
                    }}
                    height={30}
                    fontSize={12}
                    fontFamily={'poppinsLight'}
                  />
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
        </Grid>
      </Grid>
    </Box>
  );
}
